import { Component, effect, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ValidationErrorComponent } from "../../../../../pages/public/register/common/validation-error/validation-error.component";

@Component({
  selector: 'personal-information',
  imports: [
    ReactiveFormsModule,
    ValidationErrorComponent
],
  templateUrl: './personal-information.component.html',
  styleUrl: './personal-information.component.scss'
})
export class PersonalInformationComponent {
  form = input.required<FormGroup>();
  editing = input.required<boolean>();

  constructor() {
    effect(() => { this.editing() ? this.form().enable() : this.form().disable(); });
  }

}
